var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { key: _vm.text, staticClass: "c-checklist-filter__item menu-item" },
    [
      _c("label", { staticClass: "c-checklist-filter__label" }, [
        _c("input", {
          staticClass: "c-checklist-filter__input",
          attrs: {
            type: _vm.type,
            name: "checklist-filter-radio",
            encodedName: _vm.encodedName
          },
          domProps: { value: _vm.value, checked: _vm.active },
          on: { change: _vm.onRadioChange }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "c-checklist-filter__text",
            style: { display: _vm.type === "hidden" ? "none" : "" }
          },
          [_vm._v(_vm._s(_vm.text))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }